import React from 'react'
import SHeaderbar from '../Components/Navbar/Header.js'
import SFooterbar from '../Components/Navbar/Footer.js'
import SatTestList from '../Components/SatTest/StudentSatTestList'
import Leftbar from '../Components/Sidebar/Leftbar'

function AssignSatTestStudentPage() {
  return (
    <div style={{ display: 'flex', minHeight: '100vh', background: '#FCFCFC' }}>
      <Leftbar />
      <div
        style={{
          flex: 1,
          minHeight: '100vh',
          display: 'flex',
          flexDirection: 'column',
          width: '100%',
          padding: 0,
          boxSizing: 'border-box',
        }}
      >
        <div style={{ flex: 1, padding: 24, minHeight: 0 }}>
          <SHeaderbar />
          <SatTestList />
          <SFooterbar />
        </div>
      </div>
    </div>
  )
}

export default AssignSatTestStudentPage
